import * as T from './types'

const Checklist = (props: T.ISVGProps) => (
  <svg
    width={props.width}
    height={props.width}
    viewBox="0 0 69 69"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4166 16.0833L14.6666 20.3333L21.75 13.25"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4166 33.0833L14.6666 37.3333L21.75 30.25"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4166 50.0833L14.6666 54.3333L21.75 47.25"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.6666 17.5H57.1666"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.6666 34.5H57.1666"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.6666 51.5H57.1666"
      stroke={props.fill}
      strokeWidth="4.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Checklist
